import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="w-full bg-[#FDFAF6] py-24 px-6 md:py-32" data-id="element-172">
      <div className="max-w-2xl mx-auto text-center" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-174">
          <div className="w-px h-16 bg-[#C4A882] opacity-30 mx-auto mb-8" data-id="element-175"></div>
          <span className="text-xs uppercase tracking-[0.2em] text-[#8FAF88] font-medium block mb-6" data-id="element-176">
            The Problem
          </span>

          <h2 className="text-4xl md:text-5xl font-light text-[#2C2C2C] mb-8 leading-tight" data-id="element-177">
            Planning Should Feel Intentional —{' '}
            <span className="italic block mt-2" data-id="element-178">Not Overwhelming</span>
          </h2>

          <p className="text-lg md:text-xl text-[#2C2C2C] font-light leading-relaxed mb-8" data-id="element-179">
            Pinterest boards. Scattered notes. Budget spreadsheets. Vendor
            emails everywhere.
          </p>

          <p className="text-base text-[#6B8F64] font-medium tracking-wide mb-10" data-id="element-180">
            Most brides don't struggle with ideas. They struggle with
            organization.
          </p>

          <p className="text-2xl font-serif italic text-[#2C2C2C] mb-12" data-id="element-181">
            The result? Stress replaces excitement.
          </p>

          <div className="w-16 h-[1px] bg-[#8FAF88] opacity-30 mx-auto mb-8" data-id="element-182"></div>

          <p className="text-lg uppercase tracking-widest text-[#2C2C2C] font-light" data-id="element-183">
            You deserve better than chaos.
          </p>
        </motion.div>
      </div>
    </section>;
}